<template>
    <admin-layout>
        <template #header>
            <div class="flex justify-between">
                <div>
                    <h2 class="text-xl font-semibold leading-tight text-white">
                        Order Detail
                    </h2>
                </div>
            </div>
        </template>
        <div class="py-12">
            <div class="mx-auto max-w-7xl sm:px-6 lg:px-8">
                <div class="grid grid-cols-2 gap-4 ">
                    <div class="py-2 bg-white border border-gray-200 rounded-md shadow-xl sm:rounded-lg">
                        <h1 class="px-2 text-xl font-semibold capitalize">{{ order.theuser.name + ' ' + order.theuser.last_name}}</h1>
                        <div class="my-1 border-b-2 border-gray-200"></div>
                        <div class="px-2">
                            <ul>
                                <li>
                                    E-mail : {{ order.theuser.email }}
                                </li>
                                <li>
                                    Phone: {{ order.theuser.phone }}
                                </li>
                                <li>
                                    Gems: {{ order.theuser.gems }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="py-2 bg-white border border-gray-200 rounded-md shadow-xl sm:rounded-lg">
                        <h1 class="px-2 text-xl font-semibold capitalize">Items List</h1>
                        <div class="my-1 border-b-2 border-gray-200"></div>
                        <div class="px-2">
                            <ul v-for="(item, index) in order.items" :key="item.id"> 
                                <li>
                                    {{ index+1 + '. ' +  item.user_cart.name }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </admin-layout>
</template>

<script>
    import AdminLayout from '@/Layouts/AdminLayout'

    export default {
        props: ["order"],
        components: {
            AdminLayout,
        },
    }
</script>